import React, { useContext, useEffect } from 'react'
import { Formik, Form } from 'formik'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'

import { Container, List } from './styles'
import { ProcessoGerenciamentoContext } from '../ProcessoGerenciamentoContext'
import { Select } from '~/components/Form'
import Item from './Item'
import { TipContext } from '~/contexts/TipContext'
import { loadTips } from '~/util/tip'

export default function () {
    const { setCodigo, tips } = useContext(TipContext)
    const {
        setoresDisponiveis, tiposDisponiveis, setSetorSelecionado, setorSelecionado, tiposDoSetor, handleUpdateSetorTipo
    } = useContext(ProcessoGerenciamentoContext)

    function getTiposNaoAlocados() {
        const alocadosIds = tiposDoSetor.map(a => a.id)

        return tiposDisponiveis.filter(a => !alocadosIds.includes(a.id))
    }

    function getSetorSelecionado() {
        return setoresDisponiveis.find(s => s.id === setorSelecionado)?.descricao || ''
    }

    useEffect(() => {
        loadTips(setCodigo, 'form_processo_setores_tipos')
    }, [])

    return (
        <Container>
            <p className="tip">{tips?.formulario}</p>

            <DragDropContext onDragEnd={handleUpdateSetorTipo}>
                {tiposDisponiveis ? (
                    <Formik
                        onSubmit={() => { }}
                        initialValues={{ setor: '' }}
                    >
                        {({ setFieldValue, values }) => (
                            <Form>
                                <Select
                                    label="Grupo"
                                    name="setor"
                                    onChange={(selected, meta) => {
                                        setFieldValue(meta.name, selected)

                                        setSetorSelecionado(selected.value)
                                    }}
                                    options={setoresDisponiveis?.map(perfil => ({
                                        label: perfil.descricao,
                                        value: perfil.id
                                    })) || []}
                                />

                                <div>
                                    <h1>Tipos de atendimento disponíveis</h1>

                                    <Droppable droppableId="disponiveis">
                                        {provided => (
                                            <List
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}
                                            >
                                                {values.setor?.value
                                                    ? getTiposNaoAlocados().map((item, index) => (
                                                        <Item
                                                            key={item.id}
                                                            draggableId={String(item.id)}
                                                            item={item}
                                                            index={index}
                                                        />
                                                    ))
                                                    : tiposDisponiveis.map((item, index) => (
                                                        <Item
                                                            key={item.id}
                                                            draggableId={String(item.id)}
                                                            item={item}
                                                            index={index}
                                                        />
                                                    ))}
                                            </List>
                                        )}
                                    </Droppable>

                                    {values.setor?.value && !tiposDisponiveis.length && (
                                        <i>Nenhum tipo disponível</i>
                                    )}
                                </div>

                                <div>
                                    {values.setor?.value ? (
                                        <>
                                            <h1>{`Tipos de atendimento adicionados ao grupo ${getSetorSelecionado()}`}</h1>

                                            <Droppable droppableId="atuais">
                                                {provided => (
                                                    <>
                                                        {tiposDoSetor && (
                                                            <List
                                                                {...provided.droppableProps}
                                                                ref={provided.innerRef}
                                                            >
                                                                {tiposDoSetor.map((item, index) => (
                                                                    <Item
                                                                        key={item.id}
                                                                        draggableId={String(item.id)}
                                                                        item={item}
                                                                        index={index}
                                                                    />
                                                                ))}
                                                            </List>
                                                        )}
                                                    </>
                                                )}
                                            </Droppable>
                                        </>
                                    ) : (
                                        <p>
                                            <i>Selecione um grupo para definir os tipos</i>
                                        </p>
                                    )}
                                </div>
                            </Form>
                        )}
                    </Formik>
                ) : (
                    <p>
                        <i>Selecione um grupo para gerenciar os tipos</i>
                    </p>
                )}
            </DragDropContext>
        </Container>
    )
}
